import React from 'react'

export default function FilterPills({
  items,
  value,
  onChange,
  allLabel = 'All',
  formatLabel = (item) => item.replace('_', ' ')
}) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => onChange('')}
        className={`px-3 py-1.5 text-sm font-medium rounded-full transition ${
          !value
            ? 'bg-sky-100 text-sky-800 ring-1 ring-sky-600'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        {allLabel}
      </button>
      {items.map((item) => (
        <button
          key={item}
          onClick={() => onChange(item)}
          className={`px-3 py-1.5 text-sm font-medium rounded-full transition capitalize ${
            value === item
              ? 'bg-sky-100 text-sky-800 ring-1 ring-sky-600'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {formatLabel(item)}
        </button>
      ))}
    </div>
  )
}
